import {Component, Input} from '@angular/core';

@Component({
    selector: 'scitis-empty-state-fallback',
    templateUrl: './empty-state-fallback.component.html',
    styleUrls: ['./empty-state-fallback.component.scss'],
    standalone: false
})
export class EmptyStateFallbackComponent {

  @Input()
  fallBackMessage: string = '';
}
